import * as slider from '../../slider';

export const initInScope = slider.createInitInScope('.js-ejb-gallery');
